<template>
  <div class="header-wrapper">
    <!-- slider over text -->
    <div v-if="!isMobileDevice"
         class="header-over-img-text-container">
      <div class="title">FOGLALJ<span>PÁLYÁT</span></div>
      <div class="line"></div>
      <div class="sub-title-one">Nézd meg hol tudsz játszani,</div>
      <div class="sub-title-two">amikor TE ráérsz!</div>
      <div class="right-container">
        <div class="text">FOGLALJ <span>MOST</span></div>
      </div>
    </div>
    <!-- ./slider over text -->
    <!-- slider img(s) -->
    <div v-if="!isMobileDevice"
         class="slider-holder">
      <div v-if="IS_CORDOVA_APP"
           class="image-holder">
        <img class="slider-image"
             src="static/img/header-1.png"/>
        <img class="slider-image"
             src="static/img/header-2.png"/>
        <img class="slider-image"
             src="static/img/header-3.png"/>
        <img class="slider-image"
             src="static/img/header-4.png"/>
      </div>
      <div v-else
           class="image-holder">
        <img class="slider-image"
             src="/static/img/header-1.png"/>
        <img class="slider-image"
             src="/static/img/header-2.png"/>
        <img class="slider-image"
             src="/static/img/header-3.png"/>
        <img class="slider-image"
             src="/static/img/header-4.png"/>
      </div>
    </div>
    <div v-else
         class="mobile-img-holder">
      <!-- TODO fix kép, látszódjon a menu felette??? -->
      <img v-if="IS_CORDOVA_APP"
           src="static/img/header-2.png"/>
      <img v-else
           src="/static/img/header-2.png"/>
    </div>
    <!-- ./slider img(s) -->
    <how-it-works :is-logged-in="isLoggedIn"
                  :is-mobile-device="isMobileDevice"/>
  </div>
</template>

<script>
import HowItWorks from '../how-it/HowItWorks'
import config from '@/config'

export default {
  props: ['isMobileDevice', 'isLoggedIn'],
  data () {
    return {
      IS_CORDOVA_APP: config.IS_CORDOVA_APP,
    }
  },
  components: {
    HowItWorks,
  },
}
</script>

<style scoped>
.header-wrapper {
  top: 0;
  left: 0;
  position: absolute;
}

.header-over-img-text-container {
  position: absolute;
  color: white;
  top: 9vw;
  left: 20vw;
  width: 60vw;
  height: 26vw;
  font-family: atf;
  z-index: 1;
}

.title {
  font-size: 5vw;
  font-weight: 800;
}

.title span {
  font-weight: 400;
}

.line {
  width: 25vw;
  border: 1px solid white;
}

.sub-title-one {
  font-size: 2.5vw;
}

.sub-title-two {
  font-size: 4vw;
  line-height: 2.5vw;
}

.right-container {
  padding-left: 40vw;
  color: rgba(255, 156, 0, 0.8);
}

.right-container .text {
  margin-top: 7vw;
  font-size: 3.5vw;
  padding-left: 1vw;
  background: rgba(0, 0, 0, .5);
}

.right-container .text span {
  font-weight: 800;
}

.right-container .text:before {
  content: "";
  width: 23vw;
  height: 26vw;
  margin-left: -24vw;
  margin-top: -21vw;
  position: absolute;
  border: 1px solid rgba(255, 156, 0, 0.8);
}

.slider-holder {
  width: 100vw;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0px;
  text-align: center;
  overflow: hidden;
}

.image-holder {
  width: 400vw;
  clear: both;
  position: relative;
  /*
  -webkit-transition: left 2s;
  -moz-transition: left 2s;
  -o-transition: left 2s;
  transition: left 2s;
  */
  animation-name: example;
  animation-duration: 20s;
  animation-iteration-count: infinite;
}

.slider-image {
  width: 100vw;
  float: left;
  margin: 0;
  padding: 0;
  position: relative;
}

#slider-image-1:target ~ .image-holder {
  left: 0;
}

#slider-image-2:target ~ .image-holder {
  left: -1900px;
}

#slider-image-3:target ~ .image-holder {
  left: -3800px;
}

.button-holder {
  position: relative;
  top: -20px;
}

.slider-change {
  display: inline-block;
  height: 10px;
  width: 10px;
  border-radius: 5px;
  background-color: brown;
}

@keyframes example {
  0% {
    left: 0
  }
  20% {
    left: 0
  }
  25% {
    left: -100vw
  }
  45% {
    left: -100vw
  }
  50% {
    left: -200vw
  }
  70% {
    left: -200vw
  }
  75% {
    left: -300vw
  }
  95% {
    left: -300vw
  }
  100% {
    left: 0
  }
}

.mobile-img-holder {
  margin-top: 3.7rem;
}

</style>
